import React, { useState, useEffect, useRef } from "react";
import "./Login.css";

const teachersData = [
  {
    id: 1,
    name: "Dr. Sameer Gupta",
    subject: "Physics",
    experience: "12 years",
    rating: 4.9,
    description:
      "Expert in NEET physics with deep concept clarity and problem-solving strategies.",
    image: "https://randomuser.me/api/portraits/men/40.jpg",
  },
  {
    id: 2,
    name: "Dr. Priya Verma",
    subject: "Chemistry",
    experience: "10 years",
    rating: 4.8,
    description:
      "Specializes in organic and physical chemistry with personalized doubt support.",
    image: "https://randomuser.me/api/portraits/women/49.jpg",
  },
  {
    id: 3,
    name: "Dr. Nikhil Sharma",
    subject: "Biology",
    experience: "15 years",
    rating: 4.9,
    description:
      "Experienced biology mentor focusing on diagrams and exam patterns.",
    image: "https://randomuser.me/api/portraits/men/52.jpg",
  },
];

function Teachers() {
  const sectionRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // 👇 Section animation (scroll par)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  // 👇 Auto slider logic
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % teachersData.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`container py-5 mt-5 teacher-section ${
        isVisible ? "fade-in-up" : "hidden-section"
      }`}
    >
      <div className="row justify-content-center align-items-center g-5">
        {/* LEFT CONTENT */}
        <div className="col-12 col-lg-8 text-center">
          <h5 className="text-uppercase fw-bold text-gold">
            Professional Mentors
          </h5>

          <h1 className="display-5 fw-bold mb-3">
            High Quality <br />
            <span className="text-dark-emphasis">Education for You</span>
          </h1>

          <p className="text-muted lead mb-4 mx-auto" style={{ maxWidth: 680 }}>
            Our expert teachers provide a supportive environment to help you
            master subjects with confidence.
          </p>

          <button className="btn btn-teacher-premium px-5 py-3 fw-bold">
            Make Appointment
          </button>
        </div>

        {/* TEACHERS CARDS */}
        <div className="col-12 mt-5">
          <div className="row g-4 justify-content-center">
            {teachersData.map((teacher, index) => (
              <div
                key={teacher.id}
                className={`col-12 col-md-6 col-lg-4 ${
                  index === currentIndex ? "active-card" : ""
                }`}
              >
                <div
                  className="card shadow-sm border-0 h-100 teacher-card"
                  style={{ borderRadius: "20px", transition: "0.3s" }}
                >
                  <div className="card-body text-center p-4">
                    <img
                      src={teacher.image}
                      alt={teacher.name}
                      className="rounded-circle mb-3"
                      style={{
                        width: 110,
                        height: 110,
                        objectFit: "cover",
                      }}
                    />

                    <h5 className="fw-bold mb-1">{teacher.name}</h5>
                    <p className="text-primary mb-1">
                      {teacher.subject}
                    </p>
                    <p className="text-muted mb-2">
                      {teacher.experience}
                    </p>

                    <p className="text-muted small">
                      {teacher.description}
                    </p>

                    <div className="mt-3">
                      <span className="badge bg-success">
                        {teacher.rating} ★
                      </span>
                    </div>

                    <button className="btn btn-outline-primary btn-sm mt-3">
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Teachers;